import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import TapIcon from "../../../services/TapIcon";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import download from "../../../services/DownloadFile";
import api from "../../../services/api";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const BulkHrmActivationUpload = forwardRef((props, ref) => {
    const access_token                      = useSelector(state => state.auth.access_token);
    const modalElem                         = useRef(null);
    const searchModal                       = useRef(null);
    const modalID                           = uuid();
    const emp_hrm_download_sample_url       = HRM_API_BASE_URL_2 + '/emp_hrm_active_sample_download';
    const emp_hrm_add_sample_url            = HRM_API_BASE_URL_2 + '/emp_hrm_active_by_excel';

    const [hrmBulkUploadFormSubmitting, setHrmBulkUploadFormSubmitting] = useState(false)

    useEffect(() => {
        modalElem.current = document.getElementById(modalID);
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        modalHandle: () => {
            openModalHandle();

        }
    }));

    const hrmModalOpen = () => searchModal.current && searchModal.current.show();
    const hrmModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    const openModalHandle = () => {
        hrmModalOpen();
    };
    const downloadSampleFile = () => {
        HttpAPICall.withAthorization("GET", emp_hrm_download_sample_url, access_token, {}, {}, (response) => {
            download.file(response.data.file_path);
            toast.success("Employee Working Sample Excel File Downloaded Successfully", { position: toast.POSITION.TOP_RIGHT, }
            );
            hrmModalClose();
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        setHrmBulkUploadFormSubmitting(true)
        const data = new FormData(document.getElementById("hrmBulkUploadForm"));
        let headers = { 'Authorization': 'Bearer ' + access_token, };
        api.server2Api.post(emp_hrm_add_sample_url, data, {
            headers: headers,
        }).then((response) => {
            toast.success(response.data.msg, {
                position: toast.POSITION.TOP_RIGHT,
            });
            hrmModalClose();
            //Load Add Item Form Data :-
            download.file(response.data.generated_file.file_path);
            setTimeout(() => {
                props.loadListingTblData();
            }, 1000);
        })
            .catch((err) => {
                toast.error(
                    err?.response?.data?.message ?? "Unable to upload Eucation Add File.",
                    { position: toast.POSITION.TOP_RIGHT }
                );
            })
            .then(() => {
                setHrmBulkUploadFormSubmitting(false)
            });
    };

    return (
        <div className="modal fade" id={modalID} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="hrmBulkUploadModalLabel">
                            Bulk Hrm Activation Upload
                        </h5>
                        <button
                            type="button"
                            disabled={hrmBulkUploadFormSubmitting}
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <form
                        onSubmit={formSubmit}
                        id="hrmBulkUploadForm"
                        method="post"
                        encType="multipart/form-data"
                    >
                        <div className="modal-body">
                            <div className="row align-items-center mb-3 mt-3">
                                <div className="col-12">
                                    <input
                                        name="document"
                                        type="file"
                                        className="form-control"
                                        required={true}
                                    />
                                </div>
                                <div className="col-12 mt-2 form-text">
                                    # Excel Sheet with Extention xls,xlm,xlsx,ods Allowed
                                </div>
                                <div className="col-12 mt-2 form-text">
                                    # Maximum 100 MB Size of Excel Sheet Allowed
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <div>
                                <Link
                                    type="button"
                                    className="float-left"
                                    href="#"
                                    onClick={downloadSampleFile}
                                >
                                    Download Sample File
                                </Link>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    disabled={hrmBulkUploadFormSubmitting}
                                    className="btn btn-secondary mx-2"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    disabled={hrmBulkUploadFormSubmitting}
                                    className="btn btn-primary"
                                >
                                    Submit{" "}
                                    {hrmBulkUploadFormSubmitting ? (
                                        <TapIcon.FontAwesomeIcon
                                            icon={TapIcon.faSyncAlt}
                                            className="fa-spin"
                                        />
                                    ) : (
                                        ""
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div >
    );
});

export default BulkHrmActivationUpload;